export const leaveTestStage = () => {
  const stage = document.querySelector('.test__container');

  if (!stage) return;

  stage.classList.remove('is-entering');
  stage.classList.add('is-leaving');
};

export const enterTestStage = (stage) => {
  if (!stage) return;

  stage.classList.remove('is-leaving', 'is-entering');
  void stage.offsetWidth;
  stage.classList.add('is-entering');
};

export const resetTestStage = (stage) => {
  if (!stage) return;

  stage.classList.remove('is-leaving');
};
